<template>

	<div class="uploader modal">

		<div class="modal-wrap">

			<div class="modal-inner">

				<h2 class="modal-title">{{ getTitle }}<span class="close" @click="close">X</span></h2>

				<div class="modal-inner-scroll">

					<div id="file-drag-drop">
						<form 
							ref="fileform" 
							:class="[{ 'drag' : dragAndDropCapable, form: true }]"
						>
							<div v-if="uploadPercentage===0">
								<div class="drop-files" v-if="uploadPercentage === 0 && dragAndDropCapable">{{ getDragText }}</div>
								<label>{{ uploadLabel }}
									<input type="file" id="file" ref="file" @change="handleFileUpload()" :multiple="multiple" />
								</label>
							</div>
							<p v-if="uploadPercentage > 0" v-html="uploadPercentage+'% complete' + ( uploadPercentage === 100 ? ' - Processing...' : '' )" class="progress-text" />
							<div class="progress" v-if="uploadPercentage > 0">
								<span :style="{width: uploadPercentage+'%'}" />
							</div>
						</form>

						<div v-if="multiple && preview">

							<div v-for="(file, key) in files" :key="key" class="file-listing">
								<img class="preview" v-bind:ref="'preview'+parseInt( key )"/>
								{{ file.name }}
								<span class="remove" @click="removeFile( key )">Remove</span>
							</div>

						</div>

						<span class="large-button" @click="handleFileUpload(1)" v-show="files.length > 0" v-if="multiple && preview">Upload</span>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
// https://serversideup.net/drag-and-drop-file-uploads-with-vuejs-and-axios/
import ApiService from './../services/api.service'

export default {
	name: 'Uploader',
	props: {
		imagesOnly: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Boolean,
			default: false
		},
		dragText: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		},
		fileTypes: {
			type: Array,
			default: function () {
				return [];
			}
		},
		uploadHandler: {
			type: String,
			default: ''
		},
		formData: {
			type: Object,
			default: function () { return {} }
		},
		action: {
			type: String,
			default: 'upload' // upload, emit
		},
		preview: {
			type: Boolean,
			default: true
		},
		uploadURI: {
			type: String,
			default: 'upload'
		}
	},
	data() {

		return {
			dragAndDropCapable: false,
			files: [],
			uploadPercentage: 0,
			uploadLabel: ""
		}

	},

	computed: {

		getDragText () {

			if ( this.dragText !== '' ) return this.dragText;

			if ( this.multiple ) {

				return this.imagesOnly === true ? "Drag your images here" : "Drag your files here";

			}

			return this.imagesOnly === true ? "Drag your image here" : "Drag your file here";

		},

		getTitle () {

			if ( this.title !== '' ) return this.title;

			if ( this.multiple ) {

				return this.imagesOnly === true ? "Upload images" : "Upload files";

			}

			return this.imagesOnly === true ? "Upload an image" : "Upload a file";

		}

	},

	methods: {

		determineDragAndDropCapable() {

			var div = document.createElement('div');

			return ( ( 'draggable' in div )
							|| ( 'ondragstart' in div && 'ondrop' in div ) )
							&& 'FormData' in window
							&& 'FileReader' in window;

		},
		close() {

			this.$emit('close-uploader');

		},
		handleFileUpload(submit) {

			var uploads = this.multiple == true ? this.$refs.file.files : [this.$refs.file.files[0]];

			for ( let i = 0; i < uploads.length; i++ ) {

				this.files.push( uploads[i] );

			}

			if ( this.uploadHandler !== '' ) {

				this[this.uploadHandler];

			}
			else if ( this.multiple && this.imagesOnly && typeof submit !== 'undefined' && this.preview ) {

				this.getImagePreviews();

			}
			else {

				this.submitFiles();

			}

		},
		getImagePreviews() {

			for( let i = 0; i < this.files.length; i++ ){

				if ( /\.(jpe?g|png|gif|webp)$/i.test( this.files[i].name ) ) {
					
					let reader = new FileReader();

					reader.addEventListener("load", function() {

						this.$refs['preview'+parseInt( i )][0].src = reader.result;

					}.bind(this), false);

					reader.readAsDataURL( this.files[i] );

				} else {

					this.$nextTick(function(){

						this.$refs['preview'+parseInt( i )][0].src = '/images/file.png';

					});

				}
			}

		},
		submitFiles() {

			let formData = new FormData(), vars = [];

			for( var i = 0; i < this.files.length; i++ ) {

				let file = this.files[i];
				formData.append('files[' + i + ']', file);

			}

			Object.keys( this.formData ).forEach( function ( formDataField ) {

				if ( formDataField === 'vars' ) {

					Object.keys( this.formData.vars ).forEach( function ( varsField ) {

						formData.set(varsField, this.formData.vars[varsField]);
						vars.push(varsField);

					}.bind(this));
					
					formData.set('vars', vars.join(','));

				}
				else {

					formData.set(formDataField, this.formData[formDataField]);

				}

			}.bind(this));
			
			if ( this.multiple === false && this.action === 'emit' ) {

				let reader = new FileReader();

				reader.addEventListener("load", function() {

					this.$emit('close-uploader', { files: [{ fileName : reader.result }] });

				}.bind(this), false);

				reader.readAsDataURL( this.files[0] );

				return;

			}

			this.$emit('started-upload');

			ApiService.post( this.uploadURI,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					onUploadProgress: function( progressEvent ) {
						this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
					}.bind(this)
				}
			).then(function(data){
				this.$emit('finished-upload');
				this.$emit('close-uploader', data.data);
			}.bind(this))
			.catch(function(err){
				this.$emit('finished-upload');
				console.log(err)
				console.log(err.response)
				console.log(err.response.data)
				this.$emit('close-uploader', { error: err.response.data.error ? err.response.data.error : err.response.statusText ? err.response.statusText : "There was an error uploading your file" });
			}.bind(this));

		},
		removeFile( key ) {

			this.files.splice( key, 1 ); 

		}
	},
	mounted() {

		this.dragAndDropCapable = this.determineDragAndDropCapable();
	 
		if ( this.dragAndDropCapable ) {

			this.uploadLabel = this.multiple === true ? "Or select them here - " : "Or select it here - ";

			['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {

				this.$refs.fileform.addEventListener(evt, function(e){

					e.preventDefault();
					e.stopPropagation();

				}.bind(this), false);

			}.bind(this));

			this.$refs.fileform.addEventListener('drop', function(e){

				for( let i = 0; i < e.dataTransfer.files.length; i++ ){

					this.files.push( e.dataTransfer.files[i] );

					if ( this.multiple && this.preview ) { 

						this.getImagePreviews(); 

					}

				}

				if ( this.multiple === false || !this.preview ) { 

					this.submitFiles(); 

				}

			}.bind(this));

		}
	}
}
</script>